import _createClass from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var ResponseEvent = /*#__PURE__*/_createClass(function ResponseEvent(event, data) {
  _classCallCheck(this, ResponseEvent);
  _defineProperty(this, "event", void 0);
  _defineProperty(this, "data", void 0);
  this.event = event;
  this.data = data;
});
export function Objeto(event, data) {
  return new ResponseEvent(event, data);
}